// extracted by mini-css-extract-plugin
export default {"close-btn":"ReturnBackBtn_close-btn__xzaM3","close-btn__icon":"ReturnBackBtn_close-btn__icon__29yXI","close-btn__label":"ReturnBackBtn_close-btn__label__kPeMM"};